import { render, staticRenderFns } from "./TagListChip.vue?vue&type=template&id=cc30d922&scoped=true&"
import script from "./TagListChip.vue?vue&type=script&lang=js&"
export * from "./TagListChip.vue?vue&type=script&lang=js&"
import style0 from "./TagListChip.vue?vue&type=style&index=0&id=cc30d922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc30d922",
  null
  
)

export default component.exports